import { supabase } from '../api/supabase';

const API_BASE = 'https://homee-api.hlancaric.workers.dev';

export interface ServiceRow {
  id: number;
  segment: string;
  type: string;
  price_per_hour: number;
  description: string | null;
}

export const JobsRepository = {
  async listServices(): Promise<ServiceRow[]> {
    const { data, error } = await supabase.from('services').select('*').order('id');
    if (error) throw error;
    return data ?? [];
  },

  async createJob(clientId: string, serviceId: number, latitude: number, longitude: number): Promise<string> {
    const { data, error } = await supabase
      .from('jobs')
      .insert({
        client_id: clientId,
        service_id: serviceId,
        location: `POINT(${longitude} ${latitude})`,
        status: 'PENDING',
        escrow_status: 'HELD',
      })
      .select('id')
      .single();

    if (error) throw error;
    return data.id as string;
  },

  async assignBestHomee(jobId: string): Promise<{ id: string; full_name: string; rating: number } | null> {
    const { data, error } = await supabase.rpc('assign_best_homee', { p_job_id: jobId });
    if (error) throw error;
    return (data && data[0]) ?? null;
  },

  async listJobsForHomee(homeeId: string) {
    const { data, error } = await supabase
      .from('jobs')
      .select('id, status, escrow_status, created_at, services(segment, type, price_per_hour)')
      .eq('homee_id', homeeId)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data ?? [];
  },

  async completeJob(jobId: string): Promise<void> {
    const { error } = await supabase
      .from('jobs')
      .update({ status: 'DONE', escrow_status: 'RELEASED' })
      .eq('id', jobId);
    if (error) throw error;
  },

  async getTracking(jobId: string) {
    const { data, error } = await supabase.rpc('get_job_tracking', { p_job_id: jobId });
    if (error) throw error;
    return (data && data[0]) ?? null;
  },

  async createCheckoutUrl(jobId: string): Promise<string> {
    const res = await fetch(`${API_BASE}/checkout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ jobId }),
    });
    const data = (await res.json()) as { url?: string; error?: string };
    if (!res.ok || !data.url) throw new Error(data.error ?? 'Platbu se nepodařilo zahájit.');
    return data.url;
  },
};
